import './instrument'

import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './app'
import { BrowserRouter as Router } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { AuthContextProvider } from 'contexts/auth-context'
import { I18nProvider } from 'contexts/i18n-context'

import { disableReactDevTools } from '@fvilers/disable-react-devtools'

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools()
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <I18nProvider>
      <AuthContextProvider>
        <Router>
          <App />
        </Router>
      </AuthContextProvider>
    </I18nProvider>
  </Sentry.ErrorBoundary>
)
